import { render, staticRenderFns } from "./customSlideMenu.vue?vue&type=template&id=50feac5c&scoped=true&"
import script from "./customSlideMenu.vue?vue&type=script&lang=js&"
export * from "./customSlideMenu.vue?vue&type=script&lang=js&"
import style0 from "./customSlideMenu.vue?vue&type=style&index=0&id=50feac5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50feac5c",
  null
  
)

export default component.exports